export default __webpack_public_path__ + "static/media/9buck.660c5b49.webp";